import { Divider } from 'components'
import SearchInput from 'components/lists/SearchInput'
import { MyOrganizationFragment } from 'generated/graphql'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import routes from 'routes'
import styled from 'styled-components'
import { colors, _ } from 'utils'
import Item from '../components/Item'

export const S = {
    Wrapper: styled.div`
        width: 100%;
        padding: 0 10px;
    `,
    Toolbar: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: -26px;
    `,
    Description: styled.div`
        margin: 32px 0;
        font-weight: 300;
        font-size: 16px;
        color: ${colors.grayDescription};
    `,
    Item: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 56px;
        padding: 16px;
        border: 1px solid ${colors.statusBorder};
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
    `,
    Link: styled(Link)`
        text-decoration: none !important;
    `
}

const Organizations = ({ organizations }: { organizations: MyOrganizationFragment[] }) => {
    const [search, setSearch] = useState('')
    return (
        <S.Wrapper>
            <S.Toolbar>
                <SearchInput
                    onChange={setSearch}
                    placeholder={_('superhome.organization.search_placeholder')}
                    debounce={200}
                    md="380px"
                />
            </S.Toolbar>
            <Divider marginTop={10} />
            <S.Description>
                {_('superhome.organization.description')}
            </S.Description>
            {(organizations || [])
                .filter((e) => (e.name).toLowerCase().includes(search.toLocaleLowerCase()))
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((organization) => (
                    <S.Link
                        to={routes.organization.getPath({ organizationId: `${organization.id}` })}
                        key={organization.id}
                    >
                        <Item name={organization.name} />
                    </S.Link>
                ))}
        </S.Wrapper>
    )
}

export default Organizations
